<template>
  <div class="pagemain">
    <div class="info_div">
      <div class="title_div2">
        <div class="title_icon"></div>
        个人信息
      </div>
      <div class="userbasic">
        <div>
          <div class="info_inner">
            <div class="name_field">用户头像：</div>
            <div>
              <img :src="bind_info.user_info.avatar" class="user_avatar" alt="" />
            </div>
          </div>
          <div class="info_inner">
            <div class="name_field">用户姓名：</div>
            <span class="name_field_txt">{{ bind_info.user_info.name }}</span>
          </div>
        </div>
        <div>
          <div class="info_inner">
            <div class="name_field">登录手机号：</div>
            <span class="name_field_txt">{{ bind_info.user_info.phone }}</span>
          </div>
          <div class="info_inner">
            <div class="name_field">用户所在部门：</div>
            <span class="name_field_txt">{{ bind_info.user_info.team_name }}</span>
            <span v-if="bind_info.user_info.dep_name" class="name_field_txt"
              >/ {{ bind_info.user_info.dep_name }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="info_div">
      <div class="title_div2">
        <div class="title_icon"></div>
        绑定微信&nbsp;<span class="iconfont iconweixin1"></span>
      </div>
      <div class="info_inner">
        <div class="name_field">绑定状态：</div>
        <span class="success_txt" @click="click_bind_wx" v-if="bind_info.bind_weixin_mp"
          >已绑定（点击可换绑）</span
        >
        <span class="warning_txt" @click="click_bind_wx" v-else
          >未绑定无法收到微信通知，点击绑定</span
        >
      </div>
      <div class="info_inner">
        <div class="name_field">微信昵称:</div>

        <img
          v-if="bind_weixin_mp_data.avatar"
          :src="bind_weixin_mp_data.avatar"
          alt=""
          class="weixin_avatar"
        />
        <span class="weixin_nickname">{{
          bind_weixin_mp_data.name ? bind_weixin_mp_data.name : "--"
        }}</span>
      </div>
    </div>

    <div class="info_div">
      <div class="title_div2">
        <div class="title_icon"></div>
        绑定钉钉&nbsp;<span class="iconfont icondingding"></span>
      </div>
      <div class="info_inner">
        <div class="name_field">绑定状态·:</div>

        <span
          class="success_txt"
          @click="click_bind_dingding"
          v-if="bind_info.bind_dingding"
          >已绑定（点击可换绑）</span
        >
        <span class="warning_txt" @click="click_bind_dingding" v-else
          >未绑定无法收到钉钉通知，点击绑定</span
        >
      </div>
      <div class="info_inner">
        <div class="name_field">钉钉昵称:</div>
        <span class="weixin_nickname">
          {{ bind_dingding_data.name ? bind_dingding_data.name : "--" }}</span
        >
      </div>
    </div>

    <Modal
      width="400"
      v-model="bind_wx_show"
      :mask-closable="false"
      title="绑定微信通知"
      :closable="true"
      @on-visible-change="bind_weixin_show_change"
      :footer-hide="true"
    >
      <div class="bind_wx_status_title">
        您还没有绑定微信，微信通知将无法收到!！ <br />
        请使用微信扫一扫关注公众号绑定
        <br />
      </div>
      <div class="bing_qr_img_div">
        <Spin fix v-if="bind_wx_qr_loading"></Spin>
        <div class="bind_qr_img">
          <img :src="bind_wx_qr_img" alt="" class="" style="width: 100%; height: 100%" />
        </div>
      </div>
    </Modal>

    <Modal
      width="400"
      v-model="bind_dingding_show"
      :mask-closable="false"
      title="绑定钉钉通知"
      :closable="true"
      @on-visible-change="bind_dingding_show_change"
      :footer-hide="true"
    >
      <div class="bind_wx_status_title">
        您还没有绑定钉钉，钉钉通知将无法收到!！ <br />
        请使用钉钉APP扫一扫绑定
        <br />
      </div>
      <div class="bing_qr_img_div">
        <Spin fix v-if="bind_dingding_qr_loading"></Spin>
        <div class="bind_qr_img">
          <img
            :src="bind_dingding_qr_img"
            alt=""
            class=""
            style="width: 100%; height: 100%"
          />
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { open_new_page, http } from "@/utils/http";

export default {
  name: "app_user_info",
  data() {
    return {
      //   user_info_data: {
      //     name: "",
      //     phone: "",
      //     avatar: "",
      //   },
      bind_info: {
        user_info: {
          name: "",
          phone: "",
          avatar: "",
          team_name: "",
          dep_name: "",
        },
        bind_dingding: false,
        bind_weixin_mp: false,
      },
      bind_weixin_mp_data: {},

      //   绑定微信弹窗
      bind_wx_show: false,
      bind_wx_qr_img: "",
      bind_wx_qr_loading: false,

      // 绑定钉钉弹窗
      bind_dingding_data: {},
      bind_dingding_show: false,
      bind_dingding_qr_img: "",
      bind_dingding_qr_loading: false,
    };
  },
  mounted() {},

  methods: {
    bind_dingding_show_change() {
      this.get_bind_info();
    },

    bind_weixin_show_change() {
      this.get_bind_info();
    },

    open() {
      this.get_bind_info();
    },

    //点击绑定微信
    click_bind_wx() {
      this.get_bind_wx_qr();
      this.bind_wx_show = true;
    },

    click_bind_dingding() {
      this.get_bind_dingding_qr();
      this.bind_dingding_show = true;
    },

    get_bind_dingding_qr() {
      var that = this;
      var obj = {};
      this.bind_dingding_qr_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/staff/user_index/bind_dingding_qr",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          console.log(333, res);
          if (res.code == 0) {
            that.bind_dingding_qr_img = res.data.qr_b64;
            that.bind_dingding_qr_loading = false;
            // that.show = true
            // that.$emit('change', 'open')
            // console.log('跳转用户中心')
            // that.$router.push({'path':'/user/index'})
          } else {
            that.$Message.info("请先登录哟~");
          }
          that.bind_wx_qr_loading = false;
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    get_bind_wx_qr() {
      var that = this;
      var obj = {};
      this.bind_wx_qr_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/staff/user_index/bind_wx_qr",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            that.bind_wx_qr_img = res.data.qr_b64;
            // that.show = true
            // that.$emit('change', 'open')
            // console.log('跳转用户中心')
            // that.$router.push({'path':'/user/index'})
          } else {
            that.$Message.info("请先登录哟~");
          }
          that.bind_wx_qr_loading = false;
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    get_bind_info() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_MESSAGE_URL + "/staff/user_index/v2/bind_platform_info",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {
            that.bind_info = res.data;
            that.bind_weixin_mp_data = res.data.bind_weixin_mp_data;
            that.bind_dingding_data = res.data.bind_dingding_data;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
          that.send_msg_loading = false;
        });
    },
  },
};
</script>

<style scoped>
.iconweixin1 {
  font-size: 18px;
  color: #04ae3f;
  margin: 0 3px;
}

.icondingding {
  font-size: 18px;
  color: #318cfa;
}

.userbasic {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.user_avatar {
  width: 40px;
  height: 40px;
  border-radius: 5px;
}

.bind_wx_status_title {
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 20px;
}

.bing_qr_img_div {
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
  position: relative;
}

.bind_qr_img {
  width: 150px;
  height: 150px;
  border: 1px solid #989898;
}
.warning_txt {
  color: red;
  cursor: pointer;
  font-size: 13px;
}

.warning_txt:hover {
  color: red;
  font-weight: 600;
}

.name_field_txt {
  font-size: 13px;
}

.success_txt {
  color: #0466dd;
  cursor: pointer;
  font-size: 13px;
}

.weixin_avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid #ccc;
  margin-right: 5px;
}

.success_txt:hover {
  font-weight: 600;
}

.name_field {
  width: 100px;
  flex-shrink: 0;
  font-size: 13px;
  display: flex;
  align-items: center;
}

.weixin_nickname {
  color: #555555;
  font-size: 13px;
}

.info_inner {
  padding: 10px 10px 5px 10px;
  height: 40px;
  display: flex;
  align-items: center;
}

.title_div2 {
  display: flex;
  align-items: center;
  margin-left: 5px;
  margin-top: 5px;
  font-weight: 600;
  font-size: 14px;
  padding-bottom: 5px;
  margin-bottom: 4px;
  border-bottom: 1px solid #f5f5f5;
}

.title_icon {
  border-radius: 3px;
  margin-right: 10px;
  height: 15px;
  width: 8px;
  background: #0466dd;
}
.info_div {
  background: #fff;
  padding: 5px 10px;
  border-radius: 5px;
  margin-bottom: 10px;
}

.pagemain {
  width: calc(100vw - 120px);
  padding: 10px;
  background: #ececec;
  min-height: 100vh;
}
</style>
